module.exports = __webpack_public_path__ + "img/epidemic_bg.dd35c132.png";